module.exports = __webpack_public_path__ + "img/perfection.6fbee1fc.png";